import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import App from './App';
import AdminPanel from './components/AdminPanel';
import { ContentProvider } from './services/contentService';

// Este frontend lite gestiona y consume su propio blob en Azure Storage:
// content-arena.json. El AdminPanel del lite edita SOLO ese archivo, sin
// poder ver ni alterar el contenido del frontend principal (content.json
// / experience 'ambiental'). Para añadir nuevos experiences a futuro basta
// con cambiar este slug.
const EXPERIENCE = 'arena';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={(
            <ContentProvider experience={EXPERIENCE}>
              <App />
            </ContentProvider>
          )}
        />
        <Route
          path="/admin"
          element={(
            <ContentProvider experience={EXPERIENCE}>
              <AdminPanel />
            </ContentProvider>
          )}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
